module.exports = __webpack_public_path__ + "img/male1.0ad40c0e.jpeg";